module.exports = __webpack_public_path__ + "img/116.13c7888b.png";